
import React from "react";
import { Box, Typography } from "@mui/material";

const AssetError = ({
    title = "Data unavailable",
    description = "Required asset data could not be retrieved.",
}) => {
    return (
        <Box
            sx={{
                borderRadius: 3,
                border: "1px solid #eef0f4",
                p: 3,
                //height: "100%",
                backgroundColor: "#fff",
                height: "128px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
            }}
        >
            <Typography variant="subtitle1" fontWeight={600} color="error">
                {title}
            </Typography>

            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, maxWidth: 320 }}
            >
                {description}
            </Typography>
        </Box>
    );
};

export default AssetError;
